// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".how-to[data-v-6a2ce202]{margin-bottom:2.5rem}.how-to__icon[data-v-6a2ce202],.how-to__title.how-to__title[data-v-6a2ce202]{margin-bottom:.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
